// extracted by mini-css-extract-plugin
export default {"setupContainer":"KioskPortal_setupContainer__wRxyU"};